/**
 * types
 */
import { ICheckbox } from './types';
/**
 * styles
 */
import { HiddenCheckbox, StyledCheckbox, Icon } from './styles';

function Checkbox(props: ICheckbox) {
    const { isSelected, onSelectHandler, color, height, width } = props;
    const onChangeHandler = () => {
        onSelectHandler?.();
    };
    return (
        <div onClick={onChangeHandler}>
            <HiddenCheckbox checked={isSelected} onChange={onChangeHandler} />
            <StyledCheckbox
                checked={isSelected}
                color={color}
                width={width}
                height={height}
            >
                <Icon viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12" />
                </Icon>
            </StyledCheckbox>
        </div>
    );
}
export default Checkbox;
